import React from "react";
import PropTypes from "prop-types";
import { RCL as useTranslation } from "../../../RCL";
import { Icon } from "../../../Icons";
import * as styles from "./SlideInMenuHeader.module.scss";

const SlideInMenuHeader = ({ id, title, isOpen, handleClose }) => (
	<div className={styles.container}>
		<p className={styles.title}>{title}</p>
		<button
			type="button"
			className={styles.closeButton}
			aria-label={useTranslation({ searchKey: "a11y-close-menu" })}
			aria-expanded={isOpen}
			aria-controls={id}
			onClick={handleClose}>
			<Icon name="close--n" />
		</button>
	</div>
);

SlideInMenuHeader.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	isOpen: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default SlideInMenuHeader;
export { SlideInMenuHeader };
